import { useKpiFigures } from "~/modules/dashboard/hooks/useKpiFigures.ts";
import { formatPercentage } from "~/utils/numberUtils.ts";

// Shows nothing for a user with no personal figures or while the figures load or fail: the KPI
// box already shows the error.
export function MonthUtilisation() {
	const { data } = useKpiFigures();

	if (!data?.personal) return null;

	return (
		<p className="text-sm text-gray-500">
			Ø Utilization Monat{" "}
			<span className="font-semibold text-gray-900">
				{formatPercentage(data.personal.month.utilisationPercentage)}
			</span>
		</p>
	);
}
